const newsItems = [
  {
    date: '2026.04.01',
    category: '重要',
    categoryColor: 'bg-pink-100 text-pink-600',
    title: '登記変更手続き中につき、一部情報が更新されていない場合がございます',
  },
  {
    date: '2026.03.15',
    category: 'お知らせ',
    categoryColor: 'bg-emerald-100 text-emerald-700',
    title: '代表者変更に伴う各種手続きを進めております。ご不便をおかけし申し訳ございません',
  },
  {
    date: '2026.02.28',
    category: 'お知らせ',
    categoryColor: 'bg-emerald-100 text-emerald-700',
    title: '新サービス「中小企業向けDXパッケージ」の提供を開始いたしました',
  },
  {
    date: '2026.01.10',
    category: 'お知らせ',
    categoryColor: 'bg-emerald-100 text-emerald-700',
    title: '2026年の営業開始のご案内。本年もどうぞよろしくお願いいたします',
  },
];

export default function NewsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-10">
          <p className="text-xs font-semibold tracking-widest text-pink-400 uppercase mb-2">News</p>
          <h2 className="text-3xl md:text-4xl font-black text-gray-800" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            お知らせ
          </h2>
        </div>

        {/* News List */}
        <div className="flex flex-col gap-3">
          {newsItems.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 bg-gray-50 rounded-xl px-5 py-4"
            >
              <span className="text-pink-400 text-xs font-semibold whitespace-nowrap">{item.date}</span>
              <span className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${item.categoryColor}`}>
                {item.category}
              </span>
              <span className="text-gray-700 text-sm flex-1 leading-relaxed">{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
